import { GroupBox, Paragraph } from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import ErrorStack from './ErrorStack';
import { messages } from './messages';
import { ErrorDetailsProps } from './types';

const ErrorDetails: React.FC<ErrorDetailsProps> = props => {
  const { code, legend, message, name: type, stack } = props;
  const { formatMessage } = useIntl();

  return (
    <GroupBox
      collapsible
      defaultCollapsed
      enableFocusPassing={false}
      legend={legend}
    >
      <GroupBox.Content tabIndex={0}>
        <Paragraph>{formatMessage(messages.type, { type })}</Paragraph>
        {code !== null && (
          <Paragraph>{formatMessage(messages.code, { code })}</Paragraph>
        )}
        <Paragraph>{formatMessage(messages.message, { message })}</Paragraph>
        {stack && <ErrorStack stack={stack} />}
      </GroupBox.Content>
    </GroupBox>
  );
};

export default memo(ErrorDetails);
